import { render, staticRenderFns } from "./DistrictMedicalOfficer.vue?vue&type=template&id=60165fd2&scoped=true"
import script from "./DistrictMedicalOfficer.vue?vue&type=script&lang=js"
export * from "./DistrictMedicalOfficer.vue?vue&type=script&lang=js"
import style0 from "./DistrictMedicalOfficer.vue?vue&type=style&index=0&id=60165fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60165fd2",
  null
  
)

export default component.exports